// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ResourceActivityOverviewTableQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  overviewFilter: PrivateSchemaTypes.AnalyticsResourceActivityFilter;
}>;


export type ResourceActivityOverviewTableQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { resources: (
      { __typename?: 'AnalyticsResourcesModel' }
      & Pick<PrivateSchemaTypes.AnalyticsResourcesModel, 'resourceActivityOverviewCount'>
      & { resourceActivityOverview: Array<(
        { __typename?: 'AnalyticsResourceActivityModel' }
        & Pick<PrivateSchemaTypes.AnalyticsResourceActivityModel, 'userDisplayName' | 'userId' | 'lastViewedAt' | 'viewsCount'>
      )> }
    ) }
  ) }
);


export const ResourceActivityOverviewTableDocument = gql`
    query ResourceActivityOverviewTable($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $overviewFilter: AnalyticsResourceActivityFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    resources {
      resourceActivityOverview(overviewFilter: $overviewFilter) {
        userDisplayName
        userId
        lastViewedAt
        viewsCount
      }
      resourceActivityOverviewCount(overviewFilter: $overviewFilter)
    }
  }
}
    `;

/**
 * __useResourceActivityOverviewTableQuery__
 *
 * To run a query within a React component, call `useResourceActivityOverviewTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceActivityOverviewTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceActivityOverviewTableQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      overviewFilter: // value for 'overviewFilter'
 *   },
 * });
 */
export function useResourceActivityOverviewTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResourceActivityOverviewTableQuery, ResourceActivityOverviewTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResourceActivityOverviewTableQuery, ResourceActivityOverviewTableQueryVariables>(ResourceActivityOverviewTableDocument, options);
      }
export function useResourceActivityOverviewTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourceActivityOverviewTableQuery, ResourceActivityOverviewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResourceActivityOverviewTableQuery, ResourceActivityOverviewTableQueryVariables>(ResourceActivityOverviewTableDocument, options);
        }
export type ResourceActivityOverviewTableQueryHookResult = ReturnType<typeof useResourceActivityOverviewTableQuery>;
export type ResourceActivityOverviewTableLazyQueryHookResult = ReturnType<typeof useResourceActivityOverviewTableLazyQuery>;
export type ResourceActivityOverviewTableQueryResult = Apollo.QueryResult<ResourceActivityOverviewTableQuery, ResourceActivityOverviewTableQueryVariables>;